import { useState } from "react";
import { Paperclip } from "lucide-react";
import FileDropZone from "@/components/common/FileDropZone";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import { useFilePreview } from "@/context/FilePreviewContext";
import { uploadChunked } from "@/components/crm/useChunkUploader";

export const PROOF_ACCEPT = "image/*,application/pdf";

/** ajout 381 — envoie la preuve (photo / PDF) d'une opération puis la rattache (une seule preuve par opération). */
export async function uploadMovementProof(movementId, file) {
  const kind = file.type === "application/pdf" ? "plan" : "photo";
  const m = await uploadChunked({ file, kind, scope: movementId, init: (p) => api.post("/crm/files/chunk-upload/init", { ...p, owner_kind: "movement_proof", owner_id: movementId }) });
  await api.post(`/treso/movements/${movementId}/proof`, { file_id: m.id });
}

/** Cellule « Preuve » : trombone → visionneuse intégrée ; sinon « Ajouter » (si droit). */
export default function MovementProof({ m, canAdd, onChanged }) {
  const { openAuthenticatedUrl } = useFilePreview();
  const [busy, setBusy] = useState(false);
  const f = m.proof;
  if (f) {
    const name = f.original_filename || f.filename || "preuve";
    return <button type="button" onClick={() => openAuthenticatedUrl(`/crm/files/${f.id}/download`, { filename: name, contentType: f.content_type || "" })} title={name} className="inline-flex items-center hover:brightness-125" style={{ gap: 4, color: "#8FB0FF", fontSize: 11 }} data-testid={`mv-proof-${m.id}`}><Paperclip size={13} /><span className="truncate" style={{ maxWidth: 110 }}>{name}</span></button>;
  }
  if (!canAdd) return <span style={{ color: "#5a5a63" }}>—</span>;
  const add = async (file) => { setBusy(true); try { await uploadMovementProof(m.id, file); toast.success("Preuve ajoutée"); onChanged?.(); } catch (e) { toast.error(e?.response?.data?.detail || "Envoi impossible"); } finally { setBusy(false); } };
  return <FileDropZone onPick={add} multiple={false} accept={PROOF_ACCEPT} compact size={26} disabled={busy} label={busy ? "Envoi…" : "Ajouter"} testId={`mv-proof-add-${m.id}`} title="Preuve · glisser-déposer ou cliquer" />;
}
